// @ts-nocheck
import {
    AccountPriceListResult,
    getPriceList,
    GetUserPriceListApiParameter,
} from "@store/Framework/Services/AccountService";
import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnError,
    HasOnSuccess,
} from "@toolkit/Modules/client-framework/HandlerCreator";

type Parameter = HasOnError<string> & HasOnSuccess<AccountPriceListResult> & GetUserPriceListApiParameter;
type HandlerType = ApiHandlerDiscreteParameter<Parameter, GetUserPriceListApiParameter, AccountPriceListResult>;

export const DispatchBeginRequestPriceList: HandlerType = props => {
    props.apiParameter = props.parameter;
    props.dispatch({
        type: "Store/Data/Accounts/BeginLoadPriceList",
    });
};

export const RequestPriceList: HandlerType = async props => {
    const apiResult = await getPriceList(props.apiParameter);
    if (apiResult.successful) {
        props.apiResult = apiResult.result;
        props.parameter.onSuccess?.(apiResult);
    } else {
        props.parameter.onError?.(apiResult.errorMessage);
    }
};

export const DispatchCompleteRequestPriceList: HandlerType = props => {
    props.dispatch({
        type: "Store/Data/Accounts/CompleteLoadPriceList",
    });
};

export const chain = [DispatchBeginRequestPriceList, RequestPriceList, DispatchCompleteRequestPriceList];

const loadPriceList = createHandlerChainRunner(chain, "LoadPriceList");
export default loadPriceList;
